// Content data for THE FLY ASSET

export const markets = [
  {
    id: 1,
    title: "Equities",
    description: "Market structure analysis, sector trends, and price-action dynamics across equity markets."
  },
  {
    id: 2,
    title: "Derivatives",
    description: "Options strategies, volatility frameworks, and risk-defined approaches to derivatives trading."
  },
  {
    id: 3,
    title: "Commodities",
    description: "Global macro-linked commodity research covering supply-demand dynamics and price behavior."
  },
  {
    id: 4,
    title: "Market Analytics",
    description: "Data-driven market behavior study, regime analysis, and systematic research frameworks."
  }
];

export const philosophy = [
  {
    id: 1,
    title: "Discipline over speculation",
    description: "We follow structured processes and rules-based frameworks rather than impulsive decisions."
  },
  {
    id: 2,
    title: "Risk management first",
    description: "Every strategy begins with understanding and controlling downside exposure."
  },
  {
    id: 3,
    title: "Data-driven decisions",
    description: "Market behavior, historical patterns, and quantitative analysis guide our approach."
  },
  {
    id: 4,
    title: "Continuous learning",
    description: "Markets evolve. We adapt through ongoing research, testing, and refinement."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Research",
    description: "Market context analysis"
  },
  {
    id: 2,
    title: "Strategy Design",
    description: "Define rules and constraints"
  },
  {
    id: 3,
    title: "Testing",
    description: "Validation and simulation"
  },
  {
    id: 4,
    title: "Risk Review",
    description: "Exposure evaluation"
  },
  {
    id: 5,
    title: "Execution & Monitoring",
    description: "Disciplined execution"
  }
];

export const researchBullets = [
  "Data analysis & market behaviour study",
  "Strategy research & validation",
  "Risk evaluation & exposure controls",
  "Monitoring & refinement"
];

export const credibilityItems = [
  {
    id: 1,
    label: "20+ years leadership experience"
  },
  {
    id: 2,
    label: "Equities • Derivatives • Commodities"
  },
  {
    id: 3,
    label: "Structured risk-first approach"
  },
  {
    id: 4,
    label: "Kolkata, India"
  }
];

export const values = [
  {
    id: 1,
    title: "Integrity",
    description: "We operate with transparency, honesty, and responsible market participation in all our activities."
  },
  {
    id: 2,
    title: "Discipline",
    description: "Structured processes and rule-based frameworks guide our decision-making and execution."
  },
  {
    id: 3,
    title: "Research-led thinking",
    description: "Every strategy is built on thorough analysis, testing, and evidence-based frameworks."
  },
  {
    id: 4,
    title: "Continuous improvement",
    description: "We evolve with markets through ongoing learning, adaptation, and process refinement."
  }
];

export const capabilities = [
  {
    id: 1,
    title: "Market Research & Analysis",
    description: "We study market behaviour, macro cues, volatility regimes, sector trends, and price-action dynamics."
  },
  {
    id: 2,
    title: "Strategy Research & Validation",
    description: "Structured development of trading ideas, tested through historical data, scenario analysis, and rule-based validation."
  },
  {
    id: 3,
    title: "Derivatives & Volatility Frameworks",
    description: "Understanding options structure, volatility dynamics, hedging considerations, and risk-defined approaches."
  },
  {
    id: 4,
    title: "Commodity Market Coverage",
    description: "Research across commodity segments, linking global factors (supply-demand, policy, FX, macro) to price behaviour."
  },
  {
    id: 5,
    title: "Risk Management & Exposure Controls",
    description: "Position sizing, drawdown awareness, volatility-based controls, and disciplined exit frameworks."
  }
];

export const processDetails = [
  {
    id: 1,
    title: "Market Context & Research",
    description: "We analyse regime, volatility, trend/mean-reversion conditions, and macro drivers."
  },
  {
    id: 2,
    title: "Strategy Design",
    description: "Define rules, constraints, and expected behaviour across different conditions."
  },
  {
    id: 3,
    title: "Testing & Simulation",
    description: "Validate through historical testing and scenario checks (stress/volatility shifts)."
  },
  {
    id: 4,
    title: "Risk Review",
    description: "Evaluate exposure, drawdowns, and behaviour under adverse conditions."
  },
  {
    id: 5,
    title: "Execution & Monitoring",
    description: "Execute with discipline and monitor for shifts; refine when conditions change."
  }
];

export const insightsPreview = [
  {
    id: 1,
    title: "Understanding Risk in Volatile Markets",
    category: "Risk Management",
    excerpt: "Exploring how volatility impacts risk frameworks and position sizing decisions."
  },
  {
    id: 2,
    title: "Options: Structure, Volatility, and Discipline",
    category: "Derivatives",
    excerpt: "A look at options mechanics, volatility behaviour, and structured approaches."
  },
  {
    id: 3,
    title: "Commodities: Global Cues & Price Behaviour",
    category: "Commodities",
    excerpt: "How global macro factors influence commodity markets and price dynamics."
  }
];

export const insightsPosts = [
  {
    id: 1,
    title: "The Role of Drawdowns in Real Trading",
    category: "Risk Management",
    date: "Coming Soon",
    excerpt: "Understanding drawdowns as an essential part of any trading framework.",
    slug: "role-of-drawdowns"
  },
  {
    id: 2,
    title: "Position Sizing: Why It Matters",
    category: "Risk Management",
    date: "Coming Soon",
    excerpt: "How proper position sizing protects capital and ensures longevity.",
    slug: "position-sizing"
  },
  {
    id: 3,
    title: "Volatility Basics for Options",
    category: "Derivatives & Volatility",
    date: "Coming Soon",
    excerpt: "Introduction to implied volatility and its role in options pricing.",
    slug: "volatility-basics"
  },
  {
    id: 4,
    title: "When Hedging Helps—and When It Doesn't",
    category: "Derivatives & Volatility",
    date: "Coming Soon",
    excerpt: "Evaluating hedging strategies and understanding their trade-offs.",
    slug: "hedging-strategies"
  },
  {
    id: 5,
    title: "Commodities and Global Macro Signals",
    category: "Commodities",
    date: "Coming Soon",
    excerpt: "Connecting global economic indicators to commodity market movements.",
    slug: "commodities-macro"
  },
  {
    id: 6,
    title: "Discipline and Process vs Predictions",
    category: "Market Behaviour",
    date: "Coming Soon",
    excerpt: "Why process consistency matters more than predicting market direction.",
    slug: "discipline-vs-predictions"
  }
];
